export default __webpack_public_path__ + "static/media/img.9fbd8072.png";